import Image0 from './img/1cream3.jpg';
import Image1 from './img/1oil3.jpg';
import Image2 from './img/1scrub5.jpg';
import Image3 from './img/1oil5.jpg';
import Image4 from './img/1cream4.jpg';
import Image5 from './img/1serum3.jpg';
import Image6 from './img/1scrub1.jpg';
import Image7 from './img/1serum2.jpg';
import Image8 from './img/1cream5.jpg';
import Image9 from './img/1tonic3.jpg';
import Image10 from './img/1tonic6.jpg';
import Image11 from './img/1tomic2.jpg';
import Image12 from './img/1cream7.jpg';
import Image13 from './img/mask3.jpg';
import Image14 from './img/scrub6.jpg';
import Image15 from './img/1cream8.jpg';
import Image16 from './img/1cream9.jpg';



export const data = [
    {
        id: 1,
        name: 'Vulcanic Ash Cream',
        info: 'Designed to provide all-around skincare.',
        searchTern: ['cream', 'all'],
        price: 30.00,
        image: Image0,
    },

    {
        id: 2,
        name: 'Super Oil',
        info: 'Special multi-zone oil, use it anywhere!',
        searchTern: ['oil', 'multi', 'all'],
        price: 20.00,
        image: Image1,
    },

    {
        id: 3,
        name: 'Scrubissimo',
        info: 'Best-selling scrub, makes baby skin.',
        searchTern: ['scrub', 'all'],
        price: 22.00,
        image: Image2,
    },

    {
        id: 4,
        name: 'Nature Oil',
        info: 'Easily absorbed, works to nourish skin',
        searchTern: ['oil', 'multi', 'all'],
        price: 16.00,
        image: Image3,
    },

    {
        id: 5,
        name: 'Rose Clay Mask',
        info: 'Nourishing mask with rose clay.',
        searchTern: ['mask', 'all'],
        price: 20.00,
        image: Image4,
    },

    {
        id: 6,
        name: 'Magic Oil',
        info: 'Hydrating, rejuvenating face oil.',
        searchTern: ['oil', 'all'],
        price: 24.00,
        image: Image5,
    },

    {
        id: 7,
        name: 'Lip Scrub',
        info: 'Pedrfect scrub for your lips!',
        searchTern: ['lip', 'scrub', 'all'],
        price: 26.00,
        image: Image6,
    },

    {
        id: 8,
        name: 'Neck Oil',
        info: 'Get your neck wrinkle-free!',
        searchTern: ['oil', 'all'],
        price: 25.00,
        image: Image7,
    },

    {
        id: 9,
        name: 'All-In-One',
        info: 'Moisturezer for whole body!',
        searchTern: ['oil', 'multi', 'all'],
        price: 19.00,
        image: Image8,
    },

    {
        id: 10,
        name: 'Tonic',
        info: 'Unique everyday light tonic.',
        searchTern: ['body', 'tonic', 'multi', 'all'],
        price: 18.00,
        image: Image9,
    },

    {
        id: 11,
        name: 'Body Oil',
        info: 'Nourishing, silky body oil.',
        searchTern: ['oil', 'body', 'all'],
        price: 18.00,
        image: Image10,
    },

    {
        id: 12,
        name: 'Thermal Tonic',
        info: 'Soothing, hydrating thermal tonic.',
        searchTern: ['tonic', 'all'],
        price: 24.00,
        image: Image11,
    },

    {
        id: 13,
        name: 'Gel Cream',
        info: 'Perfect moisture for oily skin.',
        searchTern: ['cream', 'all'],
        price: 15.50,
        image: Image12,
    },

    {
        id: 14,
        name: 'Vegan Mask',
        info: 'All natural vegan face mask.',
        searchTern: ['mask', 'all'],
        price: 23.00,
        image: Image13,
    },

    {
        id: 15,
        name: 'Dear Scrub',
        info: 'Use it for evey type of skin!',
        searchTern: ['scrub', 'body', 'all'],
        price: 28.00,
        image: Image14,
    },

    {
        id: 16,
        name: 'Aloe Vera Cream',
        info: 'Perfectly light moisturizing cream.',
        searchTern: ['cream', 'multi', 'all'],
        price: 21.00,
        image: Image15,
    },

    {
        id: 17,
        name: 'Lip Balm',
        info: 'Premium lip balm for dry skin.',
        searchTern: ['lip', 'all'],
        price: 18.00,
        image: Image16,
    },
]




